// Turkey provinces and districts
export const provinces = [
  { code: "32", name: "Isparta" },
  { code: "15", name: "Burdur" },
  { code: "01", name: "Adana" },
  { code: "02", name: "Adıyaman" },
  { code: "03", name: "Afyonkarahisar" },
  { code: "04", name: "Ağrı" },
  { code: "05", name: "Amasya" },
  { code: "06", name: "Ankara" },
  { code: "07", name: "Antalya" },
  { code: "08", name: "Artvin" },
  { code: "09", name: "Aydın" },
  { code: "10", name: "Balıkesir" },
  { code: "11", name: "Bilecik" },
  { code: "12", name: "Bingöl" },
  { code: "13", name: "Bitlis" },
  { code: "14", name: "Bolu" },
  { code: "16", name: "Bursa" },
  { code: "17", name: "Çanakkale" },
  { code: "18", name: "Çankırı" },
  { code: "19", name: "Çorum" },
  { code: "20", name: "Denizli" },
  { code: "21", name: "Diyarbakır" },
  { code: "22", name: "Edirne" },
  { code: "23", name: "Elazığ" },
  { code: "24", name: "Erzincan" },
  { code: "25", name: "Erzurum" },
  { code: "26", name: "Eskişehir" },
  { code: "27", name: "Gaziantep" },
  { code: "28", name: "Giresun" },
  { code: "29", name: "Gümüşhane" },
  { code: "30", name: "Hakkari" },
  { code: "31", name: "Hatay" },
  { code: "33", name: "Mersin" },
  { code: "34", name: "İstanbul" },
  { code: "35", name: "İzmir" },
  { code: "36", name: "Kars" },
  { code: "37", name: "Kastamonu" },
  { code: "38", name: "Kayseri" },
  { code: "39", name: "Kırklareli" },
  { code: "40", name: "Kırşehir" },
  { code: "41", name: "Kocaeli" },
  { code: "42", name: "Konya" },
  { code: "43", name: "Kütahya" },
  { code: "44", name: "Malatya" },
  { code: "45", name: "Manisa" },
  { code: "46", name: "Kahramanmaraş" },
  { code: "47", name: "Mardin" },
  { code: "48", name: "Muğla" },
  { code: "49", name: "Muş" },
  { code: "50", name: "Nevşehir" },
  { code: "51", name: "Niğde" },
  { code: "52", name: "Ordu" },
  { code: "53", name: "Rize" },
  { code: "54", name: "Sakarya" },
  { code: "55", name: "Samsun" },
  { code: "56", name: "Siirt" },
  { code: "57", name: "Sinop" },
  { code: "58", name: "Sivas" },
  { code: "59", name: "Tekirdağ" },
  { code: "60", name: "Tokat" },
  { code: "61", name: "Trabzon" },
  { code: "62", name: "Tunceli" },
  { code: "63", name: "Şanlıurfa" },
  { code: "64", name: "Uşak" },
  { code: "65", name: "Van" },
  { code: "66", name: "Yozgat" },
  { code: "67", name: "Zonguldak" },
  { code: "68", name: "Aksaray" },
  { code: "69", name: "Bayburt" },
  { code: "70", name: "Karaman" },
  { code: "71", name: "Kırıkkale" },
  { code: "72", name: "Batman" },
  { code: "73", name: "Şırnak" },
  { code: "74", name: "Bartın" },
  { code: "75", name: "Ardahan" },
  { code: "76", name: "Iğdır" },
  { code: "77", name: "Yalova" },
  { code: "78", name: "Karabük" },
  { code: "79", name: "Kilis" },
  { code: "80", name: "Osmaniye" },
  { code: "81", name: "Düzce" }
];

export const districts = {
  "32": ["Merkez", "Aksu", "Atabey", "Eğirdir", "Gelendost", "Gönen", "Keçiborlu", "Senirkent", "Sütçüler", "Şarkikaraağaç", "Uluborlu", "Yalvaç", "Yenişarbademli"],
  "15": ["Merkez", "Ağlasun", "Altınyayla", "Bucak", "Çavdır", "Çeltikçi", "Gölhisar", "Karamanlı", "Kemer", "Tefenni", "Yeşilova"],
  "01": ["Seyhan", "Ceyhan", "Feke", "Karaisalı", "Karataş", "Kozan", "Pozantı", "Saimbeyli", "Tufanbeyli", "Yumurtalık", "Yüreğir", "Aladağ", "İmamoğlu", "Sarıçam", "Çukurova"],
  "06": ["Altındağ", "Çankaya", "Etimesgut", "Keçiören", "Mamak", "Sincan", "Yenimahalle", "Gölbaşı", "Pursaklar", "Akyurt", "Ayaş", "Bala", "Beypazarı", "Çamlıdere", "Çubuk", "Elmadağ", "Evren", "Haymana", "Kahramankazan", "Kalecik", "Kızılcahamam", "Nallıhan", "Polatlı", "Şereflikoçhisar"],
  "34": ["Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler", "Bakırköy", "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü", "Beyoğlu", "Büyükçekmece", "Çatalca", "Çekmeköy", "Esenler", "Esenyurt", "Eyüpsultan", "Fatih", "Gaziosmanpaşa", "Güngören", "Kadıköy", "Kağıthane", "Kartal", "Küçükçekmece", "Maltepe", "Pendik", "Sancaktepe", "Sarıyer", "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli", "Tuzla", "Ümraniye", "Üsküdar", "Zeytinburnu"],
  "35": ["Aliağa", "Balçova", "Bayındır", "Bayraklı", "Bergama", "Beydağ", "Bornova", "Buca", "Çeşme", "Çiğli", "Dikili", "Foça", "Gaziemir", "Güzelbahçe", "Karabağlar", "Karaburun", "Karşıyaka", "Kemalpaşa", "Kınık", "Kiraz", "Konak", "Menderes", "Menemen", "Narlıdere", "Ödemiş", "Seferihisar", "Selçuk", "Tire", "Torbalı", "Urla"],
  "07": ["Akseki", "Aksu", "Alanya", "Demre", "Döşemealtı", "Elmalı", "Finike", "Gazipaşa", "Gündoğmuş", "İbradı", "Kaş", "Kemer", "Kepez", "Konyaaltı", "Korkuteli", "Kumluca", "Manavgat", "Muratpaşa", "Serik"]
};

// Default to Merkez for provinces without detailed districts
export const getDistricts = (provinceCode) => {
  return districts[provinceCode] || ["Merkez"];
};
